import React, { useState, useMemo } from 'react';
import { Search, Copy } from 'lucide-react';
import AppendixPageLayout from '../components/AppendixPageLayout';

const TOC = [
  { id: 'overview', label: 'Overview' },
  { id: 'mastercard', label: 'Mastercard' },
  { id: 'visa', label: 'Visa' },
  { id: 'maestro', label: 'Maestro' },
];

/* Full dataset — verbatim from dev.ecomm365.com/ecommerce/Appendix-E.html */

const MASTERCARD = [
  ['Mastercard Debit',           '5424320000000751', '001', '12/2025', '3D Secure Successful',                              'Successful'],
  ['Mastercard Debit',           '5424320000000819', '001', '12/2025', '3D Secure Successful',                              'Successful'],
  ['Mastercard Debit',           '5424320000000918', '001', '12/2025', 'Attempt_complete',                                  'Successful'],
  ['Mastercard Debit',           '5424320000000850', '001', '12/2025', '3D Secure Activation During Shopping',              'Successful'],
  ['Mastercard Debit',           '5424320000000991', '001', '12/2025', '3D Secure Not Successful',                          'Decline Sale Payment Failed'],
  ['Mastercard Credit',          '5423110020225251', '001', '12/2025', '3D Secure Successful',                              'Successful'],
  ['Mastercard Credit',          '5423110024521234', '001', '12/2025', '3D Secure Activation During Shopping',              'Successful'],
  ['Mastercard Credit',          '5423110020221110', '001', '12/2025', 'Attempt_complete',                                  'Successful'],
  ['Mastercard Credit',          '5423110020223322', '001', '12/2025', 'Non 3D Secure (Card not enrolled for 3D Secure)',   'Successful'],
  ['Mastercard Credit',          '5423119500000340', '001', '12/2025', 'Non 3D Secure (Card not enrolled for 3D Secure)',   'Successful'],
  ['Mastercard Business Credit', '5480667790781284', '001', '12/2025', 'Non 3D Secure (Card not enrolled for 3D Secure)',   'Successful'],
  ['Mastercard Business Debit',  '5482251882110807', '001', '12/2025', 'Non 3D Secure (Card not enrolled for 3D Secure)',   'Successful'],
  ['Mastercard',                 '5200000000002805', '001', '12/2025', '3D Secure Successful',                              'Successful'],
];

const VISA = [
  ['VISA Debit',                 '4123709999000029', '855', '12/2031', 'Successful Frictionless Authentication',                  '—'],
  ['VISA Purchasing with Fleet', '4229989999000012', '871', '12/2031', 'Successful Frictionless Authentication',                  '—'],
  ['VISA Credit',                '4761349999000039', '998', '12/2031', 'Failed Frictionless Authentication',                      '—'],
  ['VISA Credit',                '4761349999000047', '303', '12/2031', 'Failed Frictionless Authentication',                      '—'],
  ['VISA Credit',                '4761349999000054', '905', '12/2031', 'Attempts Stand-In Frictionless Authentication',           '—'],
  ['VISA Credit',                '4761349999000062', '010', '12/2031', 'Attempts Stand-In Frictionless Authentication',           '—'],
  ['VISA Debit',                 '4761369999000078', '964', '12/2031', 'Unavailable Frictionless Authentication From the Issuer', '—'],
  ['VISA Debit',                 '4515459999000084', '217', '12/2031', 'Unavailable Frictionless Authentication From the Issuer', '—'],
  ['VISA Credit',                '4025249999000090', '621', '12/2031', 'Rejected Frictionless Authentication From the Issuer',    '—'],
  ['VISA Credit',                '4176669999000104', '012', '12/2031', 'Rejected Frictionless Authentication From the Issuer',    '—'],
  ['VISA Credit',                '4005529999000123', '196', '12/2031', 'Authentication Not Available on Lookup',                  '—'],
  ['VISA Credit',                '4761269999000138', '021', '12/2031', 'Authentication Not Available on Lookup',                  '—'],
  ['VISA Credit',                '4761129989000144', '625', '12/2031', 'Error On Lookup',                                         '—'],
  ['VISA Credit',                '4761149999000157', '035', '12/2031', 'Error On Lookup',                                         '—'],
  ['VISA Credit',                '4300069999000163', '606', '12/2031', 'Timeout on cmpi_lookup Transaction',                      '—'],
  ['VISA Debit',                 '4051469999000182', '117', '12/2031', 'Timeout on cmpi_lookup Transaction',                      '—'],
  ['VISA Debit',                 '4123649999000191', '605', '12/2031', 'Successful Step Up Authentication',                       '—'],
  ['VISA Credit',                '4123449999000204', '657', '12/2031', 'Successful Step Up Authentication',                       '—'],
  ['VISA Debit',                 '4761739999000213', '913', '12/2031', 'Failed Step Up Authentication',                           '—'],
  ['VISA Credit',                '4123229999000226', '462', '12/2031', 'Failed Step Up Authentication',                           '—'],
  ['VISA Debit',                 '4761229999000231', '078', '12/2031', 'Step Up Authentication is Unavailable',                   '—'],
  ['VISA Credit',                '4051709999000249', '961', '12/2031', 'Step Up Authentication is Unavailable',                   '—'],
  ['VISA Credit',                '4005529999000255', '786', '12/2031', 'Error On Authentication',                                 '—'],
  ['VISA Business Credit',       '4012002000019400', '369', '12/2031', 'Error On Authentication',                                 '—'],
  ['VISA Credit',                '4761409999000270', '713', '12/2031', 'Bypassed Authentication',                                 '—'],
  ['VISA Credit',                '4123569999000282', '857', '12/2031', 'Bypassed Authentication',                                 '—'],
  ['VISA Corporate Debit',       '4831961250007630', '122', '12/2031', 'Require Method URL',                                      '—'],
  ['VISA Credit',                '4109230100001002', '365', '12/2031', 'Card Authentication Failed',                              '—'],
  ['VISA Credit',                '4109230100001010', '695', '12/2031', 'Suspected Fraud',                                         '—'],
  ['VISA Credit',                '4109230200002009', '531', '12/2031', 'Cardholder Not Enrolled in Service',                      '—'],
  ['VISA Credit',                '4109230200002017', '624', '12/2031', 'Transaction Timed Out at the ACS',                        '—'],
  ['VISA Credit',                '4109230300003006', '379', '12/2031', 'Non-Payment Transaction not supported',                   '—'],
  ['VISA Credit',                '4109230300003014', '554', '12/2031', '3RI Transaction not supported',                           '—'],
];

const MAESTRO = [
  ['Maestro Debit', '6799990100000000019', '001', '12/2025', '3D Secure Successful',                              'Successful'],
  ['Maestro Debit', '6759000000005',       '001', '12/2025', 'Non 3D Secure (Card not enrolled for 3D Secure)',   "Transaction not captured: 'Invalid Card Number'"],
  ['Maestro Debit', '6705000000008',       '001', '12/2025', 'Non 3D Secure (Card not enrolled for 3D Secure)',   "Transaction not captured: 'Invalid Card Number'"],
  ['Maestro Debit', '5641820000000005',    '001', '12/2025', 'Non 3D Secure (Card not enrolled for 3D Secure)',   "Transaction not captured: 'Invalid Card Number'"],
  ['Maestro Debit', '6759649826438453',    '001', '12/2025', '3D Secure Successful',                              "Transaction not captured: 'Invalid Card Number'"],
  ['Maestro Debit', '6759411100000008',    '001', '12/2025', 'Non 3D Secure (Card not enrolled for 3D Secure)',   "Transaction not captured: 'Invalid Card Number'"],
];

/* Inline SVG brand marks — reference-only usage on test-card documentation.
   Compact, faithful to published brand specifications. */
const MastercardLogo = () => (
  <svg viewBox="0 0 48 30" width="44" height="28" role="img" aria-label="Mastercard">
    <circle cx="19" cy="15" r="11" fill="#EB001B" />
    <circle cx="29" cy="15" r="11" fill="#F79E1B" />
    <path d="M24 7a11 11 0 0 1 0 16 11 11 0 0 1 0-16z" fill="#FF5F00" />
  </svg>
);

const VisaLogo = () => (
  <svg viewBox="0 0 60 20" width="52" height="18" role="img" aria-label="Visa">
    <text x="0" y="16" fontFamily="Helvetica, Arial, sans-serif" fontSize="18" fontStyle="italic" fontWeight="900" fill="#1A1F71" letterSpacing="-0.5">VISA</text>
  </svg>
);

const MaestroLogo = () => (
  <svg viewBox="0 0 48 30" width="44" height="28" role="img" aria-label="Maestro">
    <circle cx="19" cy="15" r="11" fill="#0099DF" />
    <circle cx="29" cy="15" r="11" fill="#ED0006" />
    <path d="M24 7a11 11 0 0 1 0 16 11 11 0 0 1 0-16z" fill="#6C1E55" opacity="0.9" />
  </svg>
);

const CardTable = ({ id, title, rows, testidPrefix, Logo }) => {
  const [q, setQ] = useState('');
  const filtered = useMemo(() => {
    const s = q.trim().toLowerCase();
    if (!s) return rows;
    return rows.filter((r) => r.some((cell) => String(cell).toLowerCase().includes(s)));
  }, [q, rows]);

  const copy = (pan) => {
    if (navigator.clipboard) navigator.clipboard.writeText(pan);
  };

  return (
    <section id={id} className="bg-white/80 backdrop-blur-sm rounded-lg shadow-md p-8 mb-8 scroll-mt-28">
      <div className="flex items-center justify-between gap-3 mb-4 flex-wrap">
        <div className="flex items-center gap-3">
          <Logo />
          <h2 className="text-2xl font-bold text-gray-900">{title}</h2>
        </div>
        <div className="relative">
          <Search size={14} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
          <input
            type="text"
            value={q}
            onChange={(e) => setQ(e.target.value)}
            placeholder="Filter…"
            className="pl-8 pr-3 py-2 w-60 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#1F4E79]/30 focus:border-[#1F4E79]"
            data-testid={`${testidPrefix}-filter`}
          />
        </div>
      </div>

      <p className="text-sm text-gray-600 mb-3">Below lists the available {title} Test Cards which can be used for testing when integrating to our services.</p>

      <div className="overflow-x-auto">
        <table className="w-full text-left border border-gray-200 rounded-lg overflow-hidden min-w-[720px]">
          <thead className="bg-gray-100 border-b border-gray-200">
            <tr>
              <th className="p-3 text-xs font-bold text-gray-700 uppercase tracking-wider">Card Type</th>
              <th className="p-3 text-xs font-bold text-gray-700 uppercase tracking-wider">Card Number</th>
              <th className="p-3 text-xs font-bold text-gray-700 uppercase tracking-wider">CVV</th>
              <th className="p-3 text-xs font-bold text-gray-700 uppercase tracking-wider">Expiry</th>
              <th className="p-3 text-xs font-bold text-gray-700 uppercase tracking-wider">3D Secure Experience</th>
              <th className="p-3 text-xs font-bold text-gray-700 uppercase tracking-wider">Outcome</th>
            </tr>
          </thead>
          <tbody>
            {filtered.map((r, i) => (
              <tr key={r[1] + i} className="border-b border-gray-200 hover:bg-gray-50 transition-colors">
                <td className="p-3 text-sm text-gray-700 align-top">{r[0]}</td>
                <td className="p-3 align-top">
                  <div className="flex items-center gap-2">
                    <code className="font-mono text-sm font-bold text-[#1F4E79]">{r[1]}</code>
                    <button
                      type="button"
                      onClick={() => copy(r[1])}
                      className="p-1 rounded hover:bg-gray-100 text-gray-400 hover:text-[#1F4E79] transition-colors"
                      aria-label={`Copy ${r[1]}`}
                      data-testid={`${testidPrefix}-copy-${r[1]}`}
                    >
                      <Copy size={12} />
                    </button>
                  </div>
                </td>
                <td className="p-3 font-mono text-sm text-gray-700 align-top">{r[2]}</td>
                <td className="p-3 font-mono text-sm text-gray-700 align-top whitespace-nowrap">{r[3]}</td>
                <td className="p-3 text-xs text-gray-600 align-top">{r[4]}</td>
                <td className="p-3 text-xs align-top">
                  <span className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-semibold border ${
                    /successful/i.test(r[5]) ? 'bg-emerald-50 text-emerald-800 border-emerald-200' :
                    /decline|fail/i.test(r[5]) ? 'bg-rose-50 text-rose-800 border-rose-200' :
                    /not captured/i.test(r[5]) ? 'bg-amber-50 text-amber-800 border-amber-200' :
                    'bg-gray-100 text-gray-700 border-gray-200'
                  }`}>
                    {r[5]}
                  </span>
                </td>
              </tr>
            ))}
            {filtered.length === 0 && (
              <tr><td colSpan={6} className="p-6 text-center text-sm text-gray-500">No cards match "{q}".</td></tr>
            )}
          </tbody>
        </table>
      </div>
      <p className="text-xs text-gray-500 mt-3">{filtered.length} of {rows.length} cards shown.</p>
    </section>
  );
};

const TestCards = () => (
  <AppendixPageLayout
    currentId="test-cards"
    title="Test Cards"
    subtitle="Safe test card numbers for development and testing environments. Covers the full range of 3D Secure flows — frictionless, step-up, attempts, bypass — plus success and decline scenarios."
    toc={TOC}
    mainTestId="appendix-test-cards-page"
    sidebarTestId="appendix-test-cards-sidebar"
  >
    <section id="overview" className="bg-white/80 backdrop-blur-sm rounded-lg shadow-md p-8 mb-8 scroll-mt-28">
      <h2 className="text-2xl font-bold text-gray-900 mb-3">Overview</h2>
      <p className="text-gray-700 leading-relaxed mb-3">
        Use these card numbers only in <strong>staging</strong>. They won't move real funds, won't create real card-holder exposure, and are designed to exercise a specific 3D Secure or decline pathway. Click the copy icon beside any PAN to copy it to your clipboard.
      </p>
      <p className="text-gray-700 leading-relaxed mb-3">
        Total: <strong>{MASTERCARD.length + VISA.length + MAESTRO.length} test cards</strong> across {3} schemes — {MASTERCARD.length} Mastercard, {VISA.length} Visa, {MAESTRO.length} Maestro.
      </p>
      <div className="rounded-md border border-amber-300 bg-amber-50 p-3 text-sm text-amber-900">
        <strong>Please note</strong> that these test cards are subject to change.
      </div>
    </section>

    <CardTable id="mastercard" title="Mastercard" rows={MASTERCARD} testidPrefix="tc-mc"      Logo={MastercardLogo} />
    <CardTable id="visa"       title="Visa"       rows={VISA}       testidPrefix="tc-visa"    Logo={VisaLogo} />
    <CardTable id="maestro"    title="Maestro"    rows={MAESTRO}    testidPrefix="tc-maestro" Logo={MaestroLogo} />
  </AppendixPageLayout>
);

export default TestCards;
